




// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import PaymentIcon from "@mui/icons-material/Payment";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import StarIcon from "@mui/icons-material/Star";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import BathtubIcon from "@mui/icons-material/Bathtub";
// import KitchenIcon from "@mui/icons-material/Kitchen";
// import WeekendIcon from "@mui/icons-material/Weekend";
// import YardIcon from "@mui/icons-material/Yard";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import AppleIcon from "@mui/icons-material/Apple";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import MobileIcon from "@mui/icons-material/MobileFriendly";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(2deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-8px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const [testimonialIndex, setTestimonialIndex] = useState(0);

//   // Hero section data (single static content, no slider)
//   const heroContent = {
//     title: "Airbnb Cleaning",
//     highlight: "Made Simple",
//     description: "The mobile app that automatically schedules cleanings based on your property size. Perfect pricing for bedrooms, bathrooms, and extra services.",
//     chip: "🏠 Made for Airbnb Hosts",
//     mainImage: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=400&fit=crop", // Clean room image
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop", // Backyard/outdoor image
//     cta1: "Scan to Download App",
//     cta2: "View Pricing",
//     stats: [
//       { number: "5,000+", label: "Airbnb Listings" },
//       { number: "4.9★", label: "Host Rating" },
//       { number: "15min", label: "Avg. Booking Time" },
//       { number: "98%", label: "On-Time Rate" }
//     ]
//   };

//   // Property size based pricing
//   const propertySizes = [
//     {
//       type: "Studio",
//       price: "$79",
//       description: "Perfect for studio apartments",
//       features: ["1 Bathroom", "Kitchen", "Living Area", "Basic Cleaning"],
//       popular: false
//     },
//     {
//       type: "1-Bedroom",
//       price: "$99",
//       description: "Ideal for 1-bedroom listings",
//       features: ["1 Bedroom", "1 Bathroom", "Kitchen", "Living Room", "Standard Cleaning"],
//       popular: true
//     },
//     {
//       type: "2-Bedroom",
//       price: "$149",
//       description: "Great for 2-bedroom properties",
//       features: ["2 Bedrooms", "2 Bathrooms", "Kitchen", "Living Room", "Thorough Cleaning"],
//       popular: false
//     },
//     {
//       type: "3+ Bedroom",
//       price: "$199+",
//       description: "For larger properties",
//       features: ["3+ Bedrooms", "2+ Bathrooms", "Large Kitchen", "Living Areas", "Premium Cleaning"],
//       popular: false
//     }
//   ];

//   // Extra services
//   const extraServices = [
//     { icon: <YardIcon />, name: "Lawn & Garden", price: "+$45", description: "Lawn mowing and garden maintenance" },
//     { icon: <ApartmentIcon />, name: "Balcony/Patio", price: "+$35", description: "Outdoor area cleaning" },
//     { icon: <KitchenIcon />, name: "Deep Kitchen", price: "+$25", description: "Oven, fridge, and cabinet cleaning" },
//     { icon: <BathtubIcon />, name: "Bathroom Sanitizing", price: "+$20", description: "Extra bathroom deep clean" }
//   ];

//   // Steps
//   const steps = [
//     { number: "1", icon: "📱", title: "Download Our App", description: "Get our mobile app from App Store or Google Play" },
//     { number: "2", icon: "🏠", title: "Set Up Your Property", description: "Enter bedrooms, bathrooms, and extra services needed" },
//     { number: "3", icon: "📅", title: "Sync Calendar", description: "Connect your Airbnb calendar for automatic cleaning requests" },
//     { number: "4", icon: "✨", title: "Enjoy Clean Stays", description: "We handle cleaning after every guest checkout" }
//   ];

//   // App features
//   const appFeatures = [
//     { icon: "📱", title: "Instant Booking", description: "Schedule cleanings in under 60 seconds" },
//     { icon: "📅", title: "Calendar Sync", description: "Automatically syncs with your Airbnb calendar" },
//     { icon: "💰", title: "Transparent Pricing", description: "See exactly what you'll pay before booking" },
//     { icon: "⭐", title: "Cleaner Ratings", description: "Choose from our top-rated cleaning professionals" }
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "FreshSweeper has completely transformed my hosting business. The app makes scheduling so easy!",
//       avatar: "SJ",
//       properties: "3 Properties"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Managing 12 Airbnb properties used to be a nightmare. With FreshSweeper, I can coordinate cleanings seamlessly.",
//       avatar: "MC",
//       properties: "12 Properties"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Airbnb Host",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The mobile app is a game-changer! I get notified immediately after guests check out.",
//       avatar: "ER",
//       properties: "2 Properties"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION - DOUBLE CIRCLE WITH GRAYSCALE SLIGHTLY LEFT ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<QrCode2Icon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {heroContent.stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Backyard Image (Shifted Slightly Left) */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "-30px", sm: "-40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Colorful Image (Centered) */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt={heroContent.title}
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== REST OF THE CONTENT (same as before) ========== */}
      
//       {/* Property Size Pricing */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>
//               Property-Based Pricing
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Fair pricing based on your actual property size. Pay only for what you need.
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {propertySizes.map((property, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ height: "100%", borderRadius: "12px", position: "relative", "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   {property.popular && (
//                     <Box sx={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", bgcolor: theme.palette.primary.main, color: "white", px: 3, py: 0.5, borderRadius: "16px", fontSize: "0.8rem", fontWeight: 600 }}>
//                       Most Popular
//                     </Box>
//                   )}
//                   <CardContent sx={{ p: 3, pt: property.popular ? 4 : 3, textAlign: "center" }}>
//                     <Typography variant="h5" fontWeight="600" gutterBottom>{property.type}</Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{property.description}</Typography>
//                     <Typography variant="h3" fontWeight="700" color="primary.main" sx={{ mb: 3 }}>{property.price}<Typography variant="body2" component="span" color="text.secondary">/cleaning</Typography></Typography>
//                     <Box sx={{ mb: 3, textAlign: "left" }}>
//                       {property.features.map((feature, idx) => (
//                         <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//                           <CheckCircleIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
//                           <Typography variant="body2">{feature}</Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                     <Button variant={property.popular ? "contained" : "outlined"} fullWidth>Select Plan</Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Extra Services */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Add Extra Services</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Customize your cleaning with additional services</Typography>
//           </Box>
//           <Grid container spacing={3}>
//             {extraServices.map((service, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ textAlign: "center", p: 3, "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", color: theme.palette.primary.main, margin: "0 auto 16px" }}>{service.icon}</Box>
//                   <Typography variant="h6" fontWeight="600" gutterBottom>{service.name}</Typography>
//                   <Typography variant="h5" fontWeight="700" color="primary.main" gutterBottom>{service.price}</Typography>
//                   <Typography variant="body2" color="text.secondary">{service.description}</Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* How It Works */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>How It Works</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Everything happens right from your phone</Typography>
//           </Box>
//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box sx={{ width: 80, height: 80, borderRadius: "20px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", mx: "auto", mb: 3 }}>{step.icon}</Box>
//                   <Typography variant="h5" fontWeight="600" gutterBottom>{step.title}</Typography>
//                   <Typography variant="body2" color="text.secondary">{step.description}</Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Mobile App Showcase */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Chip label="📱 Mobile App" sx={{ mb: 3, bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.dark, fontWeight: 600 }} />
//               <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Everything You Need in One App</Typography>
//               <Typography variant="h6" sx={{ color: "text.secondary", mb: 4 }}>Manage all your Airbnb cleanings from the palm of your hand.</Typography>
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 {appFeatures.map((feature, index) => (
//                   <Grid item xs={12} sm={6} key={index}>
//                     <Box sx={{ display: "flex", gap: 2 }}>
//                       <Box sx={{ width: 50, height: 50, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem" }}>{feature.icon}</Box>
//                       <Box>
//                         <Typography variant="h6" fontWeight="600" gutterBottom>{feature.title}</Typography>
//                         <Typography variant="body2" color="text.secondary">{feature.description}</Typography>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//               <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
//                 <Button variant="contained" startIcon={<AppleIcon />} sx={{ px: 3, py: 1.5 }}>Download on App Store</Button>
//                 <Button variant="outlined" sx={{ px: 3, py: 1.5 }}>Get on Google Play</Button>
//               </Stack>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${floatAnimation} 6s ease-in-out infinite` }}>
//                 <Card sx={{ borderRadius: "20px", p: 3, maxWidth: 300, mx: "auto" }}>
//                   <Box sx={{ bgcolor: theme.palette.primary.main, borderRadius: "12px", p: 3, color: "white", textAlign: "center" }}>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>FreshSweeper</Typography>
//                     <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>Airbnb Cleaning Made Simple</Typography>
//                     <Box sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: "8px", p: 2, mb: 2 }}>
//                       <Typography variant="body2" fontWeight="600">Next Cleaning: Today 2:00 PM</Typography>
//                       <Typography variant="caption">2 Bedroom • 2 Bathroom</Typography>
//                     </Box>
//                     <Stack spacing={1}>
//                       {["Schedule Cleaning", "View Calendar", "Manage Properties", "Settings"].map((item, idx) => (
//                         <Box key={idx} sx={{ bgcolor: "rgba(255,255,255,0.1)", borderRadius: "6px", p: 1 }}>
//                           <Typography variant="body2">{item}</Typography>
//                         </Box>
//                       ))}
//                     </Stack>
//                   </Box>
//                 </Card>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Testimonials */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip label="❤️ Loved by Hosts" sx={{ mb: 3, bgcolor: alpha(theme.palette.secondary.main, 0.1), color: theme.palette.secondary.dark, fontWeight: 600 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>What Our Hosts Say</Typography>
//           </Box>
//           <Box sx={{ position: "relative" }}>
//             <IconButton onClick={handlePrevTestimonial} sx={{ position: "absolute", left: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronLeftIcon />
//             </IconButton>
//             <Box sx={{ maxWidth: 800, mx: "auto" }}>
//               <Card sx={{ p: 4, textAlign: "center" }}>
//                 <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                 <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                   {[...Array(5)].map((_, i) => (<StarIcon key={i} sx={{ color: theme.palette.secondary.main }} />))}
//                 </Box>
//                 <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic" }}>"{testimonials[testimonialIndex].comment}"</Typography>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>{testimonials[testimonialIndex].avatar}</Box>
//                   <Box>
//                     <Typography variant="h6" fontWeight="600">{testimonials[testimonialIndex].name}</Typography>
//                     <Typography variant="body2" color="text.secondary">{testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}</Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>
//             <IconButton onClick={handleNextTestimonial} sx={{ position: "absolute", right: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>
//         </Container>
//       </Box>

//       {/* Final CTA */}
//       <Box sx={{ py: 10, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: "white" }}>
//             <MobileIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Ready to Simplify Your Airbnb Cleaning?</Typography>
//             <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>Download our mobile app and get your first cleaning at 20% off.</Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button variant="contained" size="large" startIcon={<QrCode2Icon />} sx={{ px: 4, py: 2, bgcolor: alpha(theme.palette.common.white, 0.2), backdropFilter: "blur(10px)", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.3) } }}>Scan QR Code</Button>
//               <Button variant="outlined" size="large" sx={{ px: 4, py: 2, borderColor: "white", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.1) } }}>Send Download Link</Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 3, opacity: 0.8 }}>Available on iOS and Android</Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;



import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Card,
  CardContent,
  useTheme,
  Fade,
  Chip,
  Stack,
  alpha,
  IconButton,
} from "@mui/material";
import { keyframes } from "@emotion/react";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaymentIcon from "@mui/icons-material/Payment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import StarIcon from "@mui/icons-material/Star";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BathtubIcon from "@mui/icons-material/Bathtub";
import KitchenIcon from "@mui/icons-material/Kitchen";
import WeekendIcon from "@mui/icons-material/Weekend";
import YardIcon from "@mui/icons-material/Yard";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import AppleIcon from "@mui/icons-material/Apple";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MobileIcon from "@mui/icons-material/MobileFriendly";

// Animations
const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(2deg); }
`;

const floatBackgroundAnimation = keyframes`
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-8px) scale(1.02); }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Home = () => {
  const theme = useTheme();
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  // Hero section data
  const heroContent = {
    title: "Airbnb Cleaning",
    highlight: "Made Simple",
    description: "The mobile app that automatically schedules cleanings based on your property size. Perfect pricing for bedrooms, bathrooms, and extra services.",
    chip: "🏠 Made for Airbnb Hosts",
    mainImage: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=400&fit=crop",
    backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
    cta1: "Scan to Download App",
    cta2: "View Pricing",
    stats: [
      { number: "5,000+", label: "Airbnb Listings" },
      { number: "4.9★", label: "Host Rating" },
      { number: "15min", label: "Avg. Booking Time" },
      { number: "98%", label: "On-Time Rate" }
    ]
  };

  // Property size based pricing
  const propertySizes = [
    {
      type: "Studio",
      price: "$79",
      description: "Perfect for studio apartments",
      features: ["1 Bathroom", "Kitchen", "Living Area", "Basic Cleaning"],
      popular: false
    },
    {
      type: "1-Bedroom",
      price: "$99",
      description: "Ideal for 1-bedroom listings",
      features: ["1 Bedroom", "1 Bathroom", "Kitchen", "Living Room", "Standard Cleaning"],
      popular: true
    },
    {
      type: "2-Bedroom",
      price: "$149",
      description: "Great for 2-bedroom properties",
      features: ["2 Bedrooms", "2 Bathrooms", "Kitchen", "Living Room", "Thorough Cleaning"],
      popular: false
    },
    {
      type: "3+ Bedroom",
      price: "$199+",
      description: "For larger properties",
      features: ["3+ Bedrooms", "2+ Bathrooms", "Large Kitchen", "Living Areas", "Premium Cleaning"],
      popular: false
    }
  ];

  // Extra services
  const extraServices = [
    { icon: <YardIcon />, name: "Lawn & Garden", price: "+$45", description: "Lawn mowing and garden maintenance" },
    { icon: <ApartmentIcon />, name: "Balcony/Patio", price: "+$35", description: "Outdoor area cleaning" },
    { icon: <KitchenIcon />, name: "Deep Kitchen", price: "+$25", description: "Oven, fridge, and cabinet cleaning" },
    { icon: <BathtubIcon />, name: "Bathroom Sanitizing", price: "+$20", description: "Extra bathroom deep clean" }
  ];

  // Steps
  const steps = [
    { number: "1", icon: "📱", title: "Download Our App", description: "Get our mobile app from App Store or Google Play" },
    { number: "2", icon: "🏠", title: "Set Up Your Property", description: "Enter bedrooms, bathrooms, and extra services needed" },
    { number: "3", icon: "📅", title: "Sync Calendar", description: "Connect your Airbnb calendar for automatic cleaning requests" },
    { number: "4", icon: "✨", title: "Enjoy Clean Stays", description: "We handle cleaning after every guest checkout" }
  ];

  // App features
  const appFeatures = [
    { icon: "📱", title: "Instant Booking", description: "Schedule cleanings in under 60 seconds" },
    { icon: "📅", title: "Calendar Sync", description: "Automatically syncs with your Airbnb calendar" },
    { icon: "💰", title: "Transparent Pricing", description: "See exactly what you'll pay before booking" },
    { icon: "⭐", title: "Cleaner Ratings", description: "Choose from our top-rated cleaning professionals" }
  ];

  // Testimonials
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Airbnb Superhost",
      location: "Miami, FL",
      rating: 5,
      comment: "FreshSweeper has completely transformed my hosting business. The app makes scheduling so easy!",
      avatar: "SJ",
      properties: "3 Properties"
    },
    {
      name: "Michael Chen",
      role: "Property Manager",
      location: "Austin, TX",
      rating: 5,
      comment: "Managing 12 Airbnb properties used to be a nightmare. With FreshSweeper, I can coordinate cleanings seamlessly.",
      avatar: "MC",
      properties: "12 Properties"
    },
    {
      name: "Emily Rodriguez",
      role: "Airbnb Host",
      location: "San Diego, CA",
      rating: 5,
      comment: "The mobile app is a game-changer! I get notified immediately after guests check out.",
      avatar: "ER",
      properties: "2 Properties"
    }
  ];

  const handleNextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrevTestimonial = () => {
    setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
      {/* ========== HERO SECTION ========== */}
      <Box
        sx={{
          position: "relative",
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
          overflow: "hidden",
          pt: { xs: 6, md: 8 },
          pb: { xs: 6, md: 10 },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            {/* Left Content - Text */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={800}>
                <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
                  <Chip
                    label={heroContent.chip}
                    sx={{
                      mb: 3,
                      background: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                      fontSize: "0.85rem",
                    }}
                  />

                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                      fontWeight: 700,
                      lineHeight: 1.1,
                      mb: 2,
                      color: theme.palette.text.primary,
                    }}
                  >
                    {heroContent.title}
                    <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
                      {heroContent.highlight}
                    </Box>
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      mb: 4,
                      fontSize: "1.1rem",
                      lineHeight: 1.6,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {heroContent.description}
                  </Typography>

                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<QrCode2Icon />}
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        borderRadius: "8px",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      {heroContent.cta1}
                    </Button>
                    <Button
                      variant="outlined"
                      size="large"
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        borderRadius: "8px",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      {heroContent.cta2}
                    </Button>
                  </Stack>

                  <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                    {heroContent.stats.map((stat, index) => (
                      <Box key={index}>
                        <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
                          {stat.number}
                        </Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary}>
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Fade>
            </Grid>

            {/* Right Content - Double Circle Images */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: { xs: 350, sm: 450, md: 500 },
                  }}
                >
                  {/* Background Circle - Grayscale Image (Positioned with your values) */}
                  <Box
                    sx={{
                      position: "absolute",
                      width: { xs: 280, sm: 380, md: 450 },
                      height: { xs: 280, sm: 380, md: 450 },
                      borderRadius: "50%",
                      overflow: "hidden",
                      filter: "grayscale(100%)",
                      opacity: 0.3,
                      animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
                      left: { xs: "30px", sm: "40px", md: "100px" },
                    }}
                  >
                    <img
                      src={heroContent.backgroundImage}
                      alt="Background"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  {/* Foreground Circle - Main Colorful Image (Centered) */}
                  <Box
                    sx={{
                      position: "relative",
                      width: { xs: 220, sm: 300, md: 360 },
                      height: { xs: 220, sm: 300, md: 360 },
                      borderRadius: "50%",
                      overflow: "hidden",
                      boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
                      animation: `${floatAnimation} 6s ease-in-out infinite`,
                      zIndex: 2,
                    }}
                  >
                    <img
                      src={heroContent.mainImage}
                      alt={heroContent.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ========== REST OF THE CONTENT ========== */}
      
      {/* Property Size Pricing */}
      <Box sx={{ py: 10 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>
              Property-Based Pricing
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              Fair pricing based on your actual property size. Pay only for what you need.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {propertySizes.map((property, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card sx={{ height: "100%", borderRadius: "12px", position: "relative", "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
                  {property.popular && (
                    <Box sx={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", bgcolor: theme.palette.primary.main, color: "white", px: 3, py: 0.5, borderRadius: "16px", fontSize: "0.8rem", fontWeight: 600 }}>
                      Most Popular
                    </Box>
                  )}
                  <CardContent sx={{ p: 3, pt: property.popular ? 4 : 3, textAlign: "center" }}>
                    <Typography variant="h5" fontWeight="600" gutterBottom>{property.type}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{property.description}</Typography>
                    <Typography variant="h3" fontWeight="700" color="primary.main" sx={{ mb: 3 }}>{property.price}<Typography variant="body2" component="span" color="text.secondary">/cleaning</Typography></Typography>
                    <Box sx={{ mb: 3, textAlign: "left" }}>
                      {property.features.map((feature, idx) => (
                        <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                          <CheckCircleIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
                          <Typography variant="body2">{feature}</Typography>
                        </Box>
                      ))}
                    </Box>
                    <Button variant={property.popular ? "contained" : "outlined"} fullWidth>Select Plan</Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Extra Services */}
      <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Add Extra Services</Typography>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>Customize your cleaning with additional services</Typography>
          </Box>
          <Grid container spacing={3}>
            {extraServices.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card sx={{ textAlign: "center", p: 3, "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
                  <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", color: theme.palette.primary.main, margin: "0 auto 16px" }}>{service.icon}</Box>
                  <Typography variant="h6" fontWeight="600" gutterBottom>{service.name}</Typography>
                  <Typography variant="h5" fontWeight="700" color="primary.main" gutterBottom>{service.price}</Typography>
                  <Typography variant="body2" color="text.secondary">{service.description}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* How It Works */}
      <Box sx={{ py: 10 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>How It Works</Typography>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>Everything happens right from your phone</Typography>
          </Box>
          <Grid container spacing={4}>
            {steps.map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box sx={{ textAlign: "center" }}>
                  <Box sx={{ width: 80, height: 80, borderRadius: "20px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", mx: "auto", mb: 3 }}>{step.icon}</Box>
                  <Typography variant="h5" fontWeight="600" gutterBottom>{step.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{step.description}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Mobile App Showcase */}
      <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Chip label="📱 Mobile App" sx={{ mb: 3, bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.dark, fontWeight: 600 }} />
              <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Everything You Need in One App</Typography>
              <Typography variant="h6" sx={{ color: "text.secondary", mb: 4 }}>Manage all your Airbnb cleanings from the palm of your hand.</Typography>
              <Grid container spacing={3} sx={{ mb: 4 }}>
                {appFeatures.map((feature, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Box sx={{ width: 50, height: 50, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem" }}>{feature.icon}</Box>
                      <Box>
                        <Typography variant="h6" fontWeight="600" gutterBottom>{feature.title}</Typography>
                        <Typography variant="body2" color="text.secondary">{feature.description}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button variant="contained" startIcon={<AppleIcon />} sx={{ px: 3, py: 1.5 }}>Download on App Store</Button>
                <Button variant="outlined" sx={{ px: 3, py: 1.5 }}>Get on Google Play</Button>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ animation: `${floatAnimation} 6s ease-in-out infinite` }}>
                <Card sx={{ borderRadius: "20px", p: 3, maxWidth: 300, mx: "auto" }}>
                  <Box sx={{ bgcolor: theme.palette.primary.main, borderRadius: "12px", p: 3, color: "white", textAlign: "center" }}>
                    <Typography variant="h6" fontWeight="700" gutterBottom>FreshSweeper</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>Airbnb Cleaning Made Simple</Typography>
                    <Box sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: "8px", p: 2, mb: 2 }}>
                      <Typography variant="body2" fontWeight="600">Next Cleaning: Today 2:00 PM</Typography>
                      <Typography variant="caption">2 Bedroom • 2 Bathroom</Typography>
                    </Box>
                    <Stack spacing={1}>
                      {["Schedule Cleaning", "View Calendar", "Manage Properties", "Settings"].map((item, idx) => (
                        <Box key={idx} sx={{ bgcolor: "rgba(255,255,255,0.1)", borderRadius: "6px", p: 1 }}>
                          <Typography variant="body2">{item}</Typography>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Testimonials */}
      <Box sx={{ py: 10 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip label="❤️ Loved by Hosts" sx={{ mb: 3, bgcolor: alpha(theme.palette.secondary.main, 0.1), color: theme.palette.secondary.dark, fontWeight: 600 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>What Our Hosts Say</Typography>
          </Box>
          <Box sx={{ position: "relative" }}>
            <IconButton onClick={handlePrevTestimonial} sx={{ position: "absolute", left: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
              <ChevronLeftIcon />
            </IconButton>
            <Box sx={{ maxWidth: 800, mx: "auto" }}>
              <Card sx={{ p: 4, textAlign: "center" }}>
                <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  {[...Array(5)].map((_, i) => (<StarIcon key={i} sx={{ color: theme.palette.secondary.main }} />))}
                </Box>
                <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic" }}>"{testimonials[testimonialIndex].comment}"</Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
                  <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>{testimonials[testimonialIndex].avatar}</Box>
                  <Box>
                    <Typography variant="h6" fontWeight="600">{testimonials[testimonialIndex].name}</Typography>
                    <Typography variant="body2" color="text.secondary">{testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}</Typography>
                  </Box>
                </Box>
              </Card>
            </Box>
            <IconButton onClick={handleNextTestimonial} sx={{ position: "absolute", right: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
              <ChevronRightIcon />
            </IconButton>
          </Box>
        </Container>
      </Box>

      {/* Final CTA */}
      <Box sx={{ py: 10, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: "center", color: "white" }}>
            <MobileIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Ready to Simplify Your Airbnb Cleaning?</Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>Download our mobile app and get your first cleaning at 20% off.</Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
              <Button variant="contained" size="large" startIcon={<QrCode2Icon />} sx={{ px: 4, py: 2, bgcolor: alpha(theme.palette.common.white, 0.2), backdropFilter: "blur(10px)", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.3) } }}>Scan QR Code</Button>
              <Button variant="outlined" size="large" sx={{ px: 4, py: 2, borderColor: "white", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.1) } }}>Send Download Link</Button>
            </Stack>
            <Typography variant="body2" sx={{ mt: 3, opacity: 0.8 }}>Available on iOS and Android</Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;